
import React, { useState } from 'react';
import FacePhoto from '../PhotoWebcam/FacePhoto';
import PickerFileUploadGallery from './PickerFileUploadGallery';

/**
 * Component for selecting or taking multiple photos in a main view.

 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param string id: component identifier
 * @param model accept: file formats and sizes accepted by the component
 * @param model photoPickerFile: component model
 * @param useState setPhotoPickerFile: state to update the component model
 * @param string titleInput: title of the dashed-line component (file selection)
 * @param boolean required:  default value is false, must be set to true if the field is required
 * @param boolean disabled: for the disabled component
 * @param boolean showBtnCamera: default value is false, must be set to true if the camera option is needed
 * @param boolean validateFace: default value is false, must be set to true if face validation is required
 * @param className heightInput: To define the size of the file upload component
 * @param boolean emptyFields: default value is false
 * @param showBtnDeleteItemGallery: If true, the delete icon is displayed in the file gallery (FilesGallerySummary).
 * @param inModal: Indicates whether the component is being used in a modal; if so, the camera component will be displayed in a separate modal
 * @param setDisplayModal: Required when used inside a modal
 * @param titleWebcam: Title displayed when the camera video stream is active
 * @param titlePreviewWebcam: Title shown after a photo is taken, along with informational text in the preview of the captured image
 * @param titleModalCamera: Title used for the modal where the camera component is displayed
 * @param {React.ComponentType|JSX.Element|null} [downloadIcon=null] - Custom icon for the download button (optional).
 * @param {React.ComponentType|JSX.Element|null} [deleteIcon=null] - Custom icon for the delete button (optional).
 * @param {boolean} [showBtnDownload=true] - If true, shows the download button when files are available.
 * @param {boolean} [apiDelete=true] - If true, deletes files using an API call; otherwise deletes locally.
 *
 */
const PhotoPickerMultiple = (
    {
        id,
        accept,
        photoPickerFile,
        setPhotoPickerFile,
        titleInput = 'drag_your_file_or',
        required,
        disabled,
        showBtnCamera,
        validateFace = false,
        heightInput = '',
        emptyFields,
        showBtnDeleteItemGallery,
        showBtnDownload=false,
        titleWebcam = '',
        titlePreviewWebcam = '',
        deleteIcon = null,
        downloadIcon = null,
        apiDelete = true
    }
) => {

    const [startup, setStartup] = useState(false);

    return (
        <>

            {(startup || photoPickerFile?.selfieSrc) ?
                <>
                    <FacePhoto
                        photoPickerFile={photoPickerFile}
                        setPhotoPickerFile={setPhotoPickerFile}
                        startup={startup}
                        setStartup={setStartup}
                        validateFace={false}
                        showModalSuggestion={false}
                        titleWebcam={titleWebcam}
                        titlePreviewWebcam={titlePreviewWebcam}
                    />
                </>

                :
                <PickerFileUploadGallery
                    id={id}
                    accept={accept}
                    photoPickerFile={photoPickerFile}
                    setPhotoPickerFile={setPhotoPickerFile}
                    titleInput={titleInput}
                    required={required}
                    disabled={disabled}
                    showBtnCamera={showBtnCamera}
                    validateFace={validateFace}
                    heightInput={heightInput}
                    emptyFields={emptyFields}
                    showBtnDeleteItemGallery={showBtnDeleteItemGallery}
                    handleStartupWebcam={() => {
                        setStartup(true)
                    }}
                    downloadIcon={downloadIcon}
                    showBtnDownload={showBtnDownload}
                    deleteIcon={deleteIcon}
                    apiDelete={apiDelete}
                />
            }

        </>
    )
}

export default PhotoPickerMultiple
